/* Contact UI only. Shopify Forms owns callback submission and validation. */
(() => {
  const initialized = new WeakSet();
  function setup(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    const choices = [...root.querySelectorAll('[data-contact-choice]')];
    const panels = [...root.querySelectorAll('[data-contact-panel]')];
    if (!choices.length) return;
    const tablist = root.querySelector('.hg-contact__choices');
    tablist.setAttribute('role', 'tablist');
    choices.forEach(choice => {
      const name = choice.dataset.contactChoice;
      choice.id = 'hg-contact-tab-' + name;
      choice.setAttribute('role', 'tab');
      choice.setAttribute('aria-controls', name);
      const panel = panels.find(p => p.dataset.contactPanel === name);
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', choice.id);
    });
    function select(name, focus = false, updateHash = false) {
      if (!panels.some(p => p.dataset.contactPanel === name)) name = 'email';
      panels.forEach(p => { p.hidden = p.dataset.contactPanel !== name; });
      choices.forEach(c => {
        const selected = c.dataset.contactChoice === name;
        c.setAttribute('aria-selected', String(selected));
        c.tabIndex = selected ? 0 : -1;
        if (selected && focus) c.focus({preventScroll:true});
      });
      if (updateHash) history.replaceState(null, '', '#' + name);
    }
    function fromLocation() {
      const hasEmailResult = !!root.querySelector('#email .form-success, #email .form-error');
select(!hasEmailResult && location.hash === '#callback' ? 'callback' : 'email');
    }
    choices.forEach((choice, i) => {
      choice.addEventListener('click', event => { event.preventDefault(); select(choice.dataset.contactChoice, false, true); });
      choice.addEventListener('keydown', event => {
        let next;
        if (['ArrowRight', 'ArrowDown'].includes(event.key)) next = (i + 1) % choices.length;
        if (['ArrowLeft', 'ArrowUp'].includes(event.key)) next = (i + choices.length - 1) % choices.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = choices.length - 1;
        if (next !== undefined) { event.preventDefault(); select(choices[next].dataset.contactChoice, true, true); }
      });
    });
    root.querySelectorAll('[data-contact-switch]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault(); select(link.dataset.contactSwitch, true, true);
    }));
    addEventListener('hashchange', fromLocation);
    root.addEventListener('shopify:block:select', () => select('callback'));
    fromLocation();
  }
  function init() { document.querySelectorAll('[data-hg-contact]').forEach(setup); }
  document.addEventListener('shopify:section:load', init);
  init();
})();
